import { ru, enUS, Locale } from 'date-fns/locale';
import i18n from '@/i18n';

const lang2CountryAdapter: Record<string, Locale> = {
  ru: ru,
  en: enUS
}

export const SELECTED_LANG = 'selected_lang'
const DEFAULT_LANG_GROUP = 'common'

export const getLocaleOptions = (): Record<string, any> => {
  const lang = i18n.language
  if (!(lang in lang2CountryAdapter)) return {}
  return { locale: lang2CountryAdapter[lang] }
}

export class Format {
  lang2CurrencyAdapter: Record<string, string> = {
    ru: 'RUB',
    en: 'USD'
  }
  
  currencyFormatter: Intl.NumberFormat
  numberFormatter: Intl.NumberFormat

  constructor(lang: string) {
    this.currencyFormatter = new Intl.NumberFormat(lang, {
      style: 'currency',
      currency: this.lang2CurrencyAdapter[lang]
    });
    this.numberFormatter = new Intl.NumberFormat(lang);
  }

  formatCurrency(price: number, options: { approx: boolean }) {
    const formatted = this.currencyFormatter.format(price);

    if (options.approx) return `≈${formatted}`;
    return formatted
  }

  formatNumber(price: number) {
    const formatted = this.numberFormatter.format(price);
    return formatted
  }
}

const loadLangGroupTranslations = async (lng: string, group: string = DEFAULT_LANG_GROUP) => {
  const res = await import(`@/locales/${lng}/${group}.json`)
  i18n.addResourceBundle(
    lng,
    'translation',
    group === DEFAULT_LANG_GROUP
      ? res.default
      : { [group]: res.default },
  )
}

export const loadLangTranslations = async (lng: string) => {
  const ns = 'translation'
  if (!i18n.hasResourceBundle(lng, ns))
    await Promise.all([
      loadLangGroupTranslations(lng),
      loadLangGroupTranslations(lng, 'auth'),
      loadLangGroupTranslations(lng, 'profile'),
      loadLangGroupTranslations(lng, 'msgs'),
      loadLangGroupTranslations(lng, 'likes'),
      loadLangGroupTranslations(lng, 'browse'),
      loadLangGroupTranslations(lng, 'terms'),
      loadLangGroupTranslations(lng, 'registration'),
    ])
  i18n.changeLanguage(lng)
}
